import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const data = this.element.dataset.flash
    
    if (!data) return
    
    const flash = JSON.parse(data)
    
    Object.entries(flash).forEach(([key, message]) => {
      const type = key
        .replace("notice", "success")
        .replace("alert", "error")
      
      if (window.toastr?.[type]) {
        window.toastr[type](message)
      }
    })
  }
}
